// export { messages as en } from './en'
// export { messages as ru } from './ru'

import { createI18n } from 'vue-i18n'

import { messages as en } from './en'
import { messages as ru } from './ru'

const messages = { en, ru }

export default createI18n({
	locale: 'en',
	messages
})
